import { AlertsAppController } from '../controller/AlertsAppController';
import { BaseWebComponentElement } from '../../framework/BaseWebComponentElement';
import { AlertsNavigationParams } from '@nirvana/shared/navigation';

export class AlertsAppWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: AlertsAppController,
    });
  }

  set externalParams(value: AlertsNavigationParams) {
    this.setAttribute('data-external-params', JSON.stringify(value));
  }

  get externalParams(): AlertsNavigationParams {
    const value = this.getAttribute('data-external-params');
    return value ? JSON.parse(value) : {};
  }
}
